const UPDATE_GRAPH_DATA_SOURCES = "graphs/UPDATE_GRAPH_DATA_SOURCES";
const SET_HIGHLIGHTED_GRAPH_DATA_SOURCE = "graphs/SET_HIGHLIGHTED_GRAPH_DATA_SOURCE";
const CLEAR_HIGHLIGHTED_GRAPH_DATA_SOURCE = "graphs/CLEAR_HIGHLIGHTED_GRAPH_DATA_SOURCE";

export default {
  UPDATE_GRAPH_DATA_SOURCES,
  SET_HIGHLIGHTED_GRAPH_DATA_SOURCE,
  CLEAR_HIGHLIGHTED_GRAPH_DATA_SOURCE,
};
